import { render } from "./AnnotationReview.vue?vue&type=template&id=1e4992f6&scoped=true"
import script from "./AnnotationReview.vue?vue&type=script&lang=js"
export * from "./AnnotationReview.vue?vue&type=script&lang=js"

import "./AnnotationReview.vue?vue&type=style&index=0&id=1e4992f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4992f6"]])

export default __exports__